import { motion } from 'framer-motion'
import ScrollReveal from '../shared/ScrollReveal'
import GradientText from '../shared/GradientText'
import { Icons } from '../shared/Icons'
import './FeatureSections.css'

export default function AirSection() {
  const detectionTypes = [
    { type: 'Hotspot', severity: 'critical', count: 3, source: 'thermal' },
    { type: 'Micro-crack', severity: 'high', count: 7, source: 'el' },
    { type: 'Cell Defect', severity: 'high', count: 4, source: 'el' },
    { type: 'Soiling', severity: 'medium', count: 12, source: 'thermal' },
    { type: 'Discoloration', severity: 'low', count: 5, source: 'visual' }
  ]

  return (
    <section className="feature-section feature-section-air" id="air">
      <div className="container">
        <div className="feature-grid">
          <div className="feature-content">
            <ScrollReveal>
              <span className="feature-badge badge-air">Aerial Intelligence</span>
            </ScrollReveal>

            <ScrollReveal delay={0.1}>
              <h2 className="feature-title">
                AI eyes{' '}
                <GradientText gradient="air">in the sky.</GradientText>
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={0.2}>
              <p className="feature-description">
                Automated drone fleet with YOLOv8-powered defect detection.
                Dual imaging: thermal reveals hotspots while EL (electroluminescence)
                exposes micro-cracks and cell defects invisible to the human eye.
                Monthly inspections catch problems before they become failures.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.3}>
              <div className="feature-stats">
                <div className="feature-stat">
                  <span className="feature-stat-value">24</span>
                  <span className="feature-stat-label">Drone APIs</span>
                </div>
                <div className="feature-stat">
                  <span className="feature-stat-value">2</span>
                  <span className="feature-stat-label">Imaging Types</span>
                </div>
                <div className="feature-stat">
                  <span className="feature-stat-value">YOLOv8</span>
                  <span className="feature-stat-label">AI Detection</span>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={0.4}>
              <div className="detection-summary">
                <h4>AI Detection Types</h4>
                <div className="detection-list">
                  {detectionTypes.map((item, i) => (
                    <div key={i} className="detection-item">
                      <span className={`detection-dot severity-${item.severity}`} />
                      <span className="detection-type">{item.type}</span>
                      <span className={`detection-source source-${item.source}`}>{item.source}</span>
                      <span className="detection-count">{item.count}</span>
                    </div>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          </div>

          <ScrollReveal animation="fadeRight" className="feature-visual">
            <div className="drone-visual">
              {/* Thermal image simulation */}
              <motion.div
                className="thermal-view"
                whileHover={{ scale: 1.02 }}
              >
                <div className="thermal-header">
                  <div className="imaging-tabs">
                    <span className="thermal-badge thermal-active">THERMAL</span>
                    <span className="thermal-badge el-badge">EL</span>
                  </div>
                  <span className="thermal-temp">32.4°C - 67.8°C</span>
                </div>
                <div className="thermal-grid">
                  {[...Array(24)].map((_, i) => {
                    const isHotspot = [5, 11, 17].includes(i)
                    const temp = isHotspot ? 0.9 : 0.3 + Math.random() * 0.3
                    return (
                      <motion.div
                        key={i}
                        className="thermal-cell"
                        style={{
                          background: isHotspot
                            ? 'linear-gradient(135deg, #FF6B6B, #FF0000)'
                            : `rgba(0, 212, 255, ${temp})`
                        }}
                        whileHover={{ scale: 1.1 }}
                      >
                        {isHotspot && (
                          <span className="hotspot-marker">!</span>
                        )}
                      </motion.div>
                    )
                  })}
                </div>
                <div className="thermal-legend">
                  <span>Cool</span>
                  <div className="thermal-gradient" />
                  <span>Hot</span>
                </div>
              </motion.div>

              {/* Detection overlay */}
              <motion.div
                className="detection-overlay"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
              >
                <div className="detection-card">
                  <span className="detection-icon">
                    <Icons.flame size={20} />
                  </span>
                  <div className="detection-info">
                    <span className="detection-title">Hotspot Detected</span>
                    <span className="detection-detail">Panel B-12 • 67.8°C</span>
                  </div>
                  <span className="detection-confidence">98%</span>
                </div>
              </motion.div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  )
}
